import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';
import withAuth from 'src/hoc/withAuth';
import useAuth from '../../../../hooks/api/useAuth';

const apiMyPipe = '/api/commercialStatistics/pipeByEmployee/';

const useStyles = createUseStyles({
  root: {
    backgroundColor: '#ffffff12',
    padding: '1.5rem',
    color: 'white !important',
  },
  description: {
    color: 'inherit',
    fontSize: '85%',
    letterSpacing: '.15em',
    textTransform: 'uppercase',
  },
  text: {
    color: 'inherit',
  },
});

const StatCard = ({ style, className }) => {
  const classes = useStyles();
  const [nbPipe, setNbPipe] = useState('___');
  const { fetch } = useAuth();

  useEffect(() => {
    let queryURL = apiMyPipe;
    const graphQL = '{ pipeByEmployee { totalCosting } }';
    queryURL += graphQL;
    fetch(queryURL, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['data']['pipeByEmployee']) {
          setNbPipe(data['data']['pipeByEmployee']['totalCosting']);
        }
      })
      .catch(() => {
        console.log('erreur fetch myPipe entity');
      });
  }, []);

  return (
    <div style={style} className={clsx(classes.root, className)}>
      <h3 className={classes.text}>
        {nbPipe + '€'}
        <small className={clsx(classes.text, 'delta-indicator', 'delta-positive')}>__%</small>
      </h3>
      <span className={classes.description}>Mon Pipe</span>
    </div>
  );
};

export default withAuth(StatCard);
